import React from 'react'
import './index.scss'
import Morf from '../../assets/individual.momo.webp'
import Eglo from '../../assets/individual.eglo.webp'
import Prinoth from '../../assets/individual.prinoth.webp'

const Individualsoftware = () => (
  <div className="individual_container">
    <h2>Inspirationen für Ihre Individualität:</h2>
    <div className="individual_wrapper">
      <div className="individual">
        <a href="/projekte/morf">
          <img src={Morf} alt="Morf Web-Applikation" href="" loading='lazy' />
        </a>
        <p>Die in der Schweiz ansässige <b>Morf AG</b> ist seit 50 Jahren im Bereich der Straßen-Markierung und Signalisation im Einsatz. Nach vielen Konzeptionsmeetings entwickelt holzweg eine <b>Web-Applikation</b> für die gesamte Auftragsabwicklung. Projektverwaltung, Kundenverwaltung, Angebotslegung und Rechnungserstellung, Einsatzdisponierung und Mitarbeiter-Verwaltung. SAP? Wird hier nicht mehr gebraucht! Wir setzten auf API-basierte SPA-Anwendungen umgesetzt mit React, Node.js, Material-UI und GraphQL. Typisierungsfehler werden effizient vermieden durch den Einsatz von TypeScript.</p>
      </div>
      <div className="individual">
        <a href="/projekte/eglo-pim">
          <img src={Eglo} alt="EGLO PIM" loading='lazy' />
        </a>
        <p>Gemeinsam mit unserem langjährigen Kunden <b>EGLO</b> wurde vor vier Jahren ein internes <b>Produktinformationsmanagement (PIM) System</b> für über 240.000 Produkte ins Leben gerufen. Das PIM System unterstützt den Weltmarktführer für Leuchten im internen Geschäftsbereich. Das komplexe PIM wurde mit Akeneo in seiner Open Source Variante umgesetzt und mit vielen Zusatzfeatures zB. SAP-Schnittstelle, Google-Drive-API, Zugriffsrechte auf Attribut-Ebene, Produkt-Historie, Bilddatenbank (DAM) etc. aufgepeppt.</p>
      </div>
      <div className="individual">
        <img src={Prinoth} alt="Prinoth Online" loading='lazy' />
        <p>Zur Beschleunigung und Verbessererung interner Abläufe, sowie der Serviceprozesse hat <b>Prinoth</b> die holzweg GmbH beauftragt ein flexibles <b>Dokumenten-Management-System</b> zu programmieren: Prinoth-Online. Auf Basis des Zend PHP- Frameworks konnten auch viele klassische CMS - Funktionen umgesetzt werden.<br />Weitere Technologien: Sencha Ext JS - ein ausgereiftes JavaScript- Web- Application Framework. Ein Schwerpunkt der individuellen Programmierung war das User-, Dokument- und Prozessspezifische Rechtemanagement.</p>
      </div>
    </div>
  </div>
)

export default Individualsoftware
